import { useInstallerContext } from '../context/InstallerContext';
import { useEffect } from 'react';
import { useHandleInstallationValidations } from './useHandleInstallationValidations';
import { useHandlePostInstallation } from './useHandlePostInstallation';
import { useModalsAndWindow } from '../context/ModalsAndWindowContext';
import { useRenderControl } from '../context/InstallerRenderControlContext';
import { Modals } from '../types';
import { shouldShowConsent } from '../utils/consent';
import { getShouldOpenNewWindow } from '../services/get-should-open-new-window';
import { useProvisionApp } from './useProvisionApp';
export const useInstallationFlow = () => {
  const {
    modals,
    setActiveModal,
    newWindowHandlers
  } = useModalsAndWindow();
  const {
    prerequisitesState,
    setInstallerUiReady
  } = useRenderControl();
  const {
    avoidPostInstallation,
    preInstallationData,
    onInstallationCompleted,
    version
  } = useInstallerContext();
  const provisionAppApi = useProvisionApp();
  const handleInstallationValidations = useHandleInstallationValidations();
  const handlePostInstallation = useHandlePostInstallation();
  const {
    app
  } = preInstallationData;
  useEffect(() => {
    if (prerequisitesState.isDetermined) {
      (async () => {
        await handleInstallationValidations();
        if (app) {
          const shouldOpenNewWindow = getShouldOpenNewWindow(app, avoidPostInstallation);
          if (shouldShowConsent(app, version)) {
            await modals.userConsent.open({
              shouldOpenNewWindow
            });
          } else {
            setInstallerUiReady();
          }
          if (shouldOpenNewWindow) {
            newWindowHandlers.openWindow();
            setActiveModal(Modals.goToOtherTab);
          } else {
            setActiveModal(Modals.installingLoader);
          }
          const provisionSuccessData = await provisionAppApi();
          if (provisionSuccessData) {
            await handlePostInstallation(provisionSuccessData, shouldOpenNewWindow);
            onInstallationCompleted(provisionSuccessData);
          }
        }
      })();
    }
  }, [app, prerequisitesState.isDetermined]);
};
//# sourceMappingURL=useInstallationFlow.js.map